import { render, staticRenderFns } from "./HcCommunities.vue?vue&type=template&id=1382d3e1&scoped=true&"
import script from "./HcCommunities.vue?vue&type=script&lang=js&"
export * from "./HcCommunities.vue?vue&type=script&lang=js&"
import style0 from "./HcCommunities.vue?vue&type=style&index=0&id=1382d3e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1382d3e1",
  null
  
)

export default component.exports